import { omit } from 'lodash';
import { CartItemOptionModel } from './CartItemOptionModel';
export class CartItemModel {
    constructor(payload) {
        const params = omit(payload, ['itemOptions']);
        Object.assign(this, params);
        const node = (itemOption) => {
            return new CartItemOptionModel(itemOption.node);
        };
        this.itemOptions = payload.itemOptions?.edges ? payload.itemOptions.edges.map(node) : [];
    }
}
